// constants used by ConfigContext

export const defaultConfig = {
  isDevMode: false,
};
